module.exports = __webpack_public_path__ + "static/media/tree-decorated.a37f3ddf.svg";